<div class="layout py-12">
  <h2 class="font-bold text-4xl leading-tight text-bleuCaliceo-300 uppercase">
    {{ 'socialEnvironment' | translate }}
  </h2>
</div>
<div class="layout py-12 bg-beige">
  <h3 class="font-bold mb-9 text-3xl leading-tight text-bleuCaliceo-300 uppercase">
    {{ 'socialEnvironment.1.title' | translate }}
  </h3>
  <div class="relative mt-7">
    @if (page > 1) {
      <div class="absolute z-10 top-[85%] md:top-0 bottom-0 left-0 right-3/4 flex justify-center items-center">
        <div (click)="page = Math.max(1, page - 1)"
             (keyup.enter)="emulateClick($event)"
             class="p-1 rounded-full border border-white stroke-white md:border-gray-500 md:stroke-gray-500 hover:stroke-bleuCaliceo-400 hover:border-bleuCaliceo-400 cursor-pointer"
             tabindex="0">
          <svg aria-hidden="true" class="w-6 h-6" focusable="false" role="presentation"
               style="display: block; fill: none;stroke-width: 5.33333; overflow: visible;"
               viewBox="0 0 32 32">
            <path d="M20 28 8.7 16.7a1 1 0 0 1 0-1.4L20 4" fill="none"></path>
          </svg>
        </div>
      </div>
    }
    @if (page < 5) {
      <div class="absolute z-10 top-[85%] md:top-0 bottom-0 left-3/4 right-0 flex justify-center items-center">
        <div (click)="page = Math.min(5, page + 1)"
             (keyup.enter)="emulateClick($event)"
             class="p-1 rounded-full border border-white stroke-white md:border-gray-500 md:stroke-gray-500 hover:stroke-bleuCaliceo-400 hover:border-bleuCaliceo-400 block cursor-pointer"
             tabindex="0">
          <svg aria-hidden="true" class="w-6 h-6" focusable="false" role="presentation"
               style="display: block; fill: none;stroke-width: 5.33333; overflow: visible;"
               viewBox="0 0 32 32">
            <path d="m12 4 11.3 11.3a1 1 0 0 1 0 1.4L12 28" fill="none"></path>
          </svg>
        </div>
      </div>
    }
    <ngx-extended-pdf-viewer [(page)]="page" [showBorders]="false" [showToolbar]="false" class="mt-7" height="385px"
                             pageViewMode="single" src="/assets/pdfs/environment.pdf"
                             zoom="page-fit">
    </ngx-extended-pdf-viewer>
  </div>
</div>
<div class="layout py-12">
  <h3 class="font-bold mb-9 text-3xl leading-tight text-bleuCaliceo-300 uppercase">
    {{ 'socialEnvironment.2.title' | translate }}
  </h3>
  <p class="font-medium text-gray-500 text-md whitespace-pre-line">
    {{ 'socialEnvironment.2.description1' | translate }}
  </p>
  <div class="w-full mt-7">
    <div class="relative w-full overflow-hidden pt-[56.25%]">
      <p>
        <iframe
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
          class="absolute top-0 bottom-0 left-0 right-0 w-full h-full border-none" frameborder="0"
          height="315" referrerpolicy="strict-origin-when-cross-origin"
          src="https://www.youtube.com/embed/ac3ppnxcD2o?si=s5VA6XpAUW9e_ipg"
          title="YouTube video player" width="560"></iframe>
      </p>
    </div>
  </div>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
    <div class="w-full aspect-[351/105] relative">
      <img alt="" class="object-contain" fill="" loading="lazy"
           ngSrc="assets/images/partner/fdf.webp">
    </div>
    <div class="w-full aspect-[1711/785] relative">
      <img alt="" class="object-contain" fill="" loading="lazy"
           ngSrc="assets/images/partner/sport.webp">
    </div>
  </div>
</div>
